import Icon from '../components/Icon.vue'

Icon.register({
  'arrow-alt-circle-down': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M504 256c0 137-111 248-248 248s-248-111-248-248 111-248 248-248 248 111 248 248zM212 140v116h-70.9c-10.7 0-16.1 13-8.5 20.5l114.9 114.3c4.7 4.7 12.2 4.7 16.9 0l114.9-114.3c7.6-7.6 2.2-20.5-8.5-20.5h-70.8v-116c0-6.6-5.4-12-12-12h-64c-6.6 0-12 5.4-12 12z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/arrow-alt-circle-down.js
// module id = 615
// module chunks = 0